import { SVGProps, Ref, forwardRef } from 'react';

export const MapFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="m8.925 1.798.906.504v13.445l-.231-.131a320 320 0 0 0-2.525-1.414h-.002q-.453-.255-.908-.506V.25L6.4.384c.826.47 1.675.941 2.525 1.414"
                    fill="currentColor"
                />
                <path d="M5.726.001 5.724 0 5.72.001z" fill="currentColor" />
                <path
                    d="M4.765.544c-.433.246-.82.464-1.143.646l-.316.178a71 71 0 0 0-.668.382c-.018.01-.055.034-.094.06l-.003.002C1.693 2.334.935 2.89.485 3.772.045 4.635 0 5.625 0 6.695v5.221c0 .562.015 1.096.09 1.537.063.374.228 1.091.885 1.524.705.466 1.457.278 1.837.147.424-.145.889-.397 1.35-.667l.017-.009.726-.45h-.14z"
                    fill="currentColor"
                />
                <path
                    d="M11.23 2.001h-.125L12 1.449l.02-.012c.429-.244.879-.479 1.303-.604.41-.122 1.16-.245 1.823.277.57.449.714 1.117.772 1.482.068.43.082.946.082 1.492v5.221c0 1.07-.045 2.06-.485 2.923-.46.901-1.241 1.463-2.112 1.994l-.011.007c-.563.336-1.117.645-1.661.95l-.006.003-.494.277z"
                    fill="currentColor"
                />
                <path d="m10.276 16-.004-.002h.009z" fill="currentColor" />
            </g>
        </g>
    </svg>
));
MapFilledSize16Glyph.displayName = 'MapFilledSize16Glyph';
